import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PromotionCodesModule from "./promotion-codes";
import SubscriptionsDashboard from "./dashboard/SubscriptionsDashboard";
import UpcomingChargesDashboard from "./dashboard/UpcomingChargesDashboard";
import PriceCataloguePage from "./price-catalogue";

// Import billing components from the billing module
const InvoiceList = lazy(() => import("../billing/components/InvoiceList"));
const InvoiceDetail = lazy(() => import("../billing/components/InvoiceDetail"));
const CompanyBillingDetail = lazy(
  () => import("../billing/components/CompanyBillingDetail")
);
const BillingTestPanel = lazy(
  () => import("../billing/components/BillingTestPanel")
);
const WalletFeeSettings = lazy(
  () => import("../billing/components/WalletFeeSettings")
);
const CryptoWalletFeeSettings = lazy(
  () =>
    import("../billing/components/crypto-wallet-fees/CryptoWalletFeeSettings")
);
const WalletUpcomingChargesDashboard = lazy(
  () => import("../billing/components/WalletUpcomingChargesDashboard")
);
const CollectionsCasesDashboard = lazy(
  () => import("./collections-cases/CollectionsCasesDashboard")
);

const SubscriptionModule = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<SubscriptionsDashboard />} />
      <Route path="upcoming-charges" element={<UpcomingChargesDashboard />} />
      <Route path="price-catalogue" element={<PriceCataloguePage />} />
      <Route path="collections-cases" element={<CollectionsCasesDashboard />} />
      <Route path="invoices" element={<InvoiceList />} />
      <Route path="invoices/:id" element={<InvoiceDetail />} />
      <Route path="companies/:companyId" element={<CompanyBillingDetail />} />
      <Route path="promotion-codes/*" element={<PromotionCodesModule />} />
      <Route path="wallet-fees" element={<WalletFeeSettings />} />
      <Route path="crypto-wallet-fees" element={<CryptoWalletFeeSettings />} />
      <Route
        path="wallet-upcoming-charges"
        element={<WalletUpcomingChargesDashboard />}
      />
      <Route path="billing-test" element={<BillingTestPanel />} />
    </Routes>
  );
};

export default SubscriptionModule;
